import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell, TableColumnCell } from '@components/common';
import Actions from '@components/common/Actions';

import { IApprovalUnit, IApprovalUser } from './interfaces';

import { columnSizes } from '@constants/table';
import { editTooltipText, removeTooltipText } from './constants';

import styles from '@components/common/Table/Table.module.scss';

export const getColumns = ({
	toggleDeleteModal,
	toggleEditModal,
	setEditUnit,
	setDeleteUnitId,
}: {
	toggleDeleteModal: () => void;
	toggleEditModal: () => void;
	setEditUnit: React.Dispatch<React.SetStateAction<IApprovalUnit | null>>;
	setDeleteUnitId: React.Dispatch<React.SetStateAction<string | null>>;
}) => ([
	{
		header: 'Approval Unit',
		accessorKey: 'name',
		size: columnSizes.size200,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();

			return <AdaptiveTableCell text={value} />;
		},
	},
	{
		header: 'Approval Users',
		accessorKey: 'users',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();
			const userList = value?.map((user: IApprovalUser) => `${user.firstName} ${user.lastName}`);

			return <TableColumnCell textList={userList} />;
		},
	},
	{
		header: () => (
			<div className={styles.centerColumnHeader}>
				Actions
			</div>
		),
		accessorKey: 'actions',
		size: columnSizes.size85,
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			const handleDelete = () => {
				setDeleteUnitId(row?.original?.id);
				toggleDeleteModal();
			};

			const handleEdit = () => {
				setEditUnit(row?.original);
				toggleEditModal();
			};

			return (
				<Actions
					deleteTooltip={removeTooltipText}
					editHandler={handleEdit}
					editTooltip={editTooltipText}
					handleDelete={handleDelete}
					isDelete
					isEdit
				/>
			);
		},
	},
]);
